import { Component } from '@angular/core';
import { SscShellComponent } from '../ssc-shell/ssc-shell';

@Component({
  selector: 'app-security-audit-page',
  standalone: true,
  imports: [SscShellComponent],
  templateUrl: './security-audit.html',
})
export class SecurityAuditPage {}
